import { render, staticRenderFns } from "./AddToOrder.vue?vue&type=template&id=1a563c62&"
import script from "./AddToOrder.vue?vue&type=script&lang=js&"
export * from "./AddToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports